<div class="content-wrapper">
  <div class="title-wrapper">
    <div class="wrapper-text-h1">Confirm Entry Flow</div>
  </div>
  <div class="card-container">
    <entry-flow-card
      [flow]="previewInfo"
      [isPreview]="true"
      [appliedRoomsName]="appliedRoomsName"
      [scootaverse]="scootaverse"
    ></entry-flow-card>
  </div>
  <div class="footer-wrapper">
    <button data-testid="primaryButton" class="primary-button" (click)="saveFlow()">
      @if (isEdit) {
        Save
      } @else {
        Create
      }
    </button>
  </div>
</div>
